import { Divider, Space } from 'antd';
import styled from 'styled-components';
import { blueLink, grayDark02, grayLight02, white } from '../../../styles/colors';

export const ModalFooterDivider = styled(Divider)`
    border-top: 1px solid ${grayLight02};
`;

export const ModalButtonContainer = styled(Space)`
    width: 100%;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 12px !important;
    &:focus {
        color: ${white};
    }
`;

export const CaptchaBlock = styled('div')`
    margin-top: 16px;
`;

export const CaptchaText = styled('p')`
    font-weight: 400;
    font-size: 11px;
    line-height: 13px;
    color: ${grayDark02};
    margin-bottom: 0px;
    margin-top: 7px;
    position: absolute;
`;

export const Link = styled('a')`
    color: ${blueLink};
    margin-bottom: 0px;
`;

export const OuterContainer = styled('div')`
    display: flex;
    justify-content: space-between;
`;
